<template>
  <div class="live_list">
      <div class="live_list-box" v-if="dataList.length">
        <template>
            <List v-model="loading" :finished="finished" @load="loadMore">
                <div class="live_list-one" v-for="(item,index) in dataList" :key="index">
                    <template v-if="item.images.length">
                        <span>{{item.origin}}</span>
                        <div class="live_list-one-main">
                            <h3 v-if="item.title || item.content">{{item.title || item.content }}</h3>
                            <p>{{item.createAt | moment("YYYY/MM/DD HH:mm:ss")}}</p>
                            <div class="live_list-img" :class="item.isShow ? 'over-img' : ''">
                                <div class="live_list-img-one" v-for="(c,idx) in item.images" :key="idx">
                                    <img :src="c.url" v-load="'oPic'"     preview="1"  :large="c.url" alt/>
                                </div>
                                <div @click="open(item)" :class="item.isShow ? 'over-show' : 'over-hide'">
                                <div class="mask"></div>
                                <div class="live_list-img-open">
                                    点击获取更多内容
                                    <i class="icon iconfont icon-xiala"></i>
                                </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div slot="loading" class="f-tac loading">
                    <img src="@assets/img/new/icon-loading.png" />
                    loading...
                </div>
             <div   div slot="finished" class="f-tac loading">It's the end~</div>
            </List>
        </template>
      </div>
      <div class="no-msg" v-else>暂无数据！</div>
      <div style="height: 49px;"></div>
  </div>
</template>

<script>
import { List } from "vant";
import { mapGetters, mapMutations, mapActions,mapState} from "vuex";
import gql from 'graphql-tag';
export default {
    name: "topic",
    data() {
      return {
        dataList: [], //图文列表
        pageSize: 10,
        pageIndex: 1,
        loading: false,
        finished: false,
        queryLiveImageTexts:{},
      };
    },
    components: { List },
    computed: {
        ...mapGetters({
            exhibitionId:'getExhibitionId',
        }),
        ImageGql(){
            return gql`query queryLiveImageTexts($query: QueryInput!){
                queryLiveImageTexts(query: $query){
                    hasNextPage
                    hasPreviousPage
                    indexFrom
                    items{
                        activityId
                        content
                        createAt
                        exhibitionId
                        id
                        imageCount
                        images(num: 50){
                            url
                        }
                        origin
                        title
                        updateAt
                    }
                    pageIndex
                    pageSize
                    totalCount
                    totalPages
                }
            }`
        },
        where(){
            return {
                "Equal":{
                    "n":"exhibitionId",
                    "v":this.exhibitionId
                },
            }
        },
        order(){
            return [
                {
                    "n":"createAt",
                    "v":0
                }
            ]
        }
    },
    created(){
        this.getImageData();
    },
    mounted: function() {
      //图片查看器打开后，打印本次查看器的实例（事件、方法、属性的示例）
      this.$preview.on("imageLoadComplete", (e, item) => {});
    },
    methods: {
        getImageData(){
            this.$apollo.addSmartQuery('queryLiveImageTexts', {
                query:this.ImageGql, 
                variables:{
                    query:{
                        page:this.pageIndex,
                        size:this.pageSize,
                        where:JSON.stringify(this.where),
                        order:JSON.stringify(this.order)
                    }
                },
                fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
                result(res) {
                    console.log(res,'-------------')
                    let data = JSON.parse(JSON.stringify(res.data));
                    if(data && data.queryLiveImageTexts.items){
                        let currentList = data.queryLiveImageTexts.items;
                        currentList.map(c=>{
                            if(c.images.length > 6){
                            c.isShow = true;
                            } else {
                            c.isShow = false;
                            }
                        })
                        if(this.pageIndex == 1){
                        this.dataList = currentList;
                        } else {
                        this.dataList = [...this.dataList,...currentList]
                        }
                        this.loading = false;
                        if (!data.queryLiveImageTexts.hasNextPage) {
                        this.finished = true;
                        }
                        console.log(this.dataList,'图片直播')
                    }
                },
                error(error) {
                    console.error(error,'error错误处理')
                }
            })
        },
        loadMore() {
            if (this.finished) return;
            this.pageIndex += 1;
            console.log(this.pageIndex,'当前加载的页面')
            this.getImageData();
        },
        open(item){
            this.dataList.map(c=>{
                if(c.id == item.id) {
                c.isShow = false
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
.live_list{
    margin-top: 10px;
    
    &-box{
        padding:.3rem 0;
        background: #fff;
    }
    &-one{
        margin:.3rem;
        background-color: #fff;
        box-shadow: 0px 0px .1rem 0px 
            rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        span{
            display: inline-block;
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // height: .36rem;
            // line-height: 0.36rem;
            padding:.04rem 8px .04rem 6px;
            font-size: .24rem;
            // line-height: 1.2;
            color: #fff;
            background-image: linear-gradient(90deg, 
                #ff416c 0%, 
                #ff4b2b 100%), 
            linear-gradient(
                #ffc7c7, 
                #ffc7c7);
            background-blend-mode: normal, 
                normal;
            border-radius: 5px 0px 5px 0px;
        }
        &-main{
            padding: 0 .24rem .36rem;
            h3{
                font-size: .26rem;
                color: #ff5c00;
                margin-top: 8px;
            }
            p{
                font-size: .2rem;
                color: #666;
                margin: 9px 0 15px;
            }
        }
        .live_list-img{
            display: flex;
            flex-wrap: wrap;
            position: relative;
            &-one{
                width: 2rem;
                height: 2rem;
                margin-right: .2rem;
                margin-bottom: .23rem;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            &-one:nth-child(3n+3){
                margin-right: 0;
            }
            .mask{
                width: 100%;
                height: .7rem;
                background-image: linear-gradient(to bottom, rgba(255,255,255,.1), rgba(255,255,255,.9));
                // background-image: linear-gradient(0deg, 
                // #fff 0%, 
                // rgba(0, 0, 0, 0.85) 58%, 
                // rgba(0, 0, 0, 0.1) 100%);
                position: absolute;
                bottom: 0px;
                left: 0;
            }
            &-open{
                width: 100%;
                text-align: center;
                margin: 10px auto 0;
                color: #4d4d4d;
                position: absolute;
                left: 0;
                bottom: 0;
                background: #fff;
            }
        }
        .over-img{
            max-height: 4.45rem;
            overflow: hidden;
        }
        .over-show{
            display: block;
        }
        .over-hide{
            display: none;
        }
    }
    &-one:first-child{
        margin-top: 0;
    }
    &-one:last-child{
        margin-bottom: 0;
    }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
